export default function isInApp(url = window.location) {
    return /app/.test(url) && !/password/.test(url);
}
